import {checkExists} from 'external/dev_april_corgi+/js/common/asserts';

export const FLOAT_REGEX = new RegExp(
  '(?<number>' + // capture the whole thing
    /(?<numerator>\d*\.?\d+)/.source + // capture the numerator
    /(?:\/(?<denominator>\d*\.?\d+))?/.source + // and maybe a slash followed by the denominator
    '(?<percent>%)?' + // and maybe a percent sign
    ')',
);

export function deserializeFloat(rawNumber: string): number {
  const {
    numerator: rawNumerator,
    denominator: rawDenominator,
    percent,
  } = checkExists(
    rawNumber.match(new RegExp('^' + FLOAT_REGEX.source + '$'))?.groups,
    'Expected a number',
  );
  const numerator = Number(rawNumerator);
  const denominator = rawDenominator ? Number(rawDenominator) : 1;
  if (!rawNumber || Number.isNaN(numerator) || Number.isNaN(denominator)) {
    throw new Error(
      `Concentration '${rawNumber}' must be a number or fraction`,
    );
  }
  let scale;
  if (percent) {
    scale = 100;
  } else {
    scale = 1;
  }
  return numerator / denominator / scale;
}
